import React from 'react'
import clsx from 'clsx'
import styles from './CardHelpers.module.scss'
import { useCommonTheme, useCurrentTheme } from '../../hooks/useCurrentTheme'
import CardBack from './CardBack'

export const suitsMapper = { s: '♠', c: '♣', h: '♥', d: '♦' }
export const suitsMapperCode = { s: <>&#9824;</>, c: <>&#9827;</>, h: <>&#9829;</>, d: <>&#9830;</> }

function CardImage({ isSmall = false, card, isInstaHand = false }) {
	const theme = useCurrentTheme()
	const { cardLayout, useCustomColors } = useCommonTheme().cards

	// cardImageSmallInstaHand
	const suitClass =
		isSmall && isSmall !== 'trainer' && isSmall !== 'board' && !isInstaHand
			? styles.cardImageSmall
			: isSmall === 'trainer'
			? styles.cardImageTrainer
			: isSmall === 'board'
			? styles.cardImageTrainerBoard
			: isInstaHand
			? styles.cardImageSmallInstaHand
			: styles.cardImage
	const sizeKey = isSmall ? 'small' : 'regular'

	const suit = card.substring(1, 2) !== '' ? card.substring(1, 2) : 'empty'
	const rank = card.substring(0, 1) !== '' ? card.substring(0, 1) : '-'

	const activeColor = useCustomColors ? theme.cards.suits[suit] : theme.cards.baseCardSuits[suit]
	if (card === '-' || rank === '-') {
		return <CardBack isSmall={isSmall} className={suitClass} />
	}

	const suitSizeHelper = {
		regular: {
			right: 30,
			top: -13,
			fontSize: '1.7rem',
		},
		small: {
			right: isInstaHand ? 3 : 21,
			top: isInstaHand ? -6 : -10,
			fontSize: isInstaHand ? '0.7rem' : '1.5rem',
			position: 'absolute',
		},
	}

	const stylesMapper = {
		regular: {
			0: {
				lineHeight: '0.5em',
				opacity: 0.4,
				fontSize: '6.5em',
				top: 24,
				left: 14,
			},
			1: {
				fontSize: '3.8em',
				lineHeight: '0.5em',
				top: 35,
				left: 10,
			},
			2: {
				fontSize: '4em',
				lineHeight: '0.5em',
				top: 32,
				left: 15,
			},
		},

		small: {
			0: {
				lineHeight: isInstaHand ? '1em' : '0.5em',
				opacity: 0.4,
				fontSize: isInstaHand ? '3em' : '3.5em',
				top: isInstaHand ? 3 : 27,
				left: isInstaHand ? 9 : 17,
			},

			1: {
				fontSize: isInstaHand ? '2em' : '2.5em',
				lineHeight: isInstaHand ? '0.4em' : '0.5em',
				top: isInstaHand ? 17 : 30,
				left: isInstaHand ? 5 : 10,
			},
			2: {
				fontSize: isInstaHand ? '2em' : '2.7em',
				lineHeight: isInstaHand ? '0.4em' : '0.5em',
				top: isInstaHand ? 16 : 26,
				left: isInstaHand ? 6 : 12,
			},
		},
	}
	const backgroundMapper = {
		0: '#fff',
		1: card === '-' ? '#15171F' : activeColor,
		2: '#fff',
	}
	const colorMapper = {
		0: activeColor,
		1: '#fff',
		2: activeColor,
	}
	const textMapper = {
		0: suitsMapper[suit],
		1: rank,
		2: rank,
	}
	const fontMapper = {
		0: 'inherit',
		1: 'Inter',
		2: 'Card Characters',
	}

	return (
		<div
			style={{
				color: colorMapper[cardLayout],
				backgroundColor: backgroundMapper[cardLayout],
				fontFamily: fontMapper[cardLayout],
			}}
			className={clsx([suitClass])}
		>
			<div className={clsx([styles.suitText])} style={{ ...stylesMapper[sizeKey][cardLayout] }}>
				{textMapper[cardLayout]}
			</div>

			{/* top 2 3 4 5 ...T*/}
			{!isInstaHand && cardLayout === 0 && <div className={styles.cardInfo}>{rank}</div>}

			{(cardLayout === 0 || cardLayout === 1) && <div className={styles.cardInfo}>{suitsMapperCode[suit]}</div>}

			{isInstaHand && cardLayout === 0 && (
				<div style={{ fontSize: '2em', position: 'absolute', top: '1px' }}>{rank}</div>
			)}

			{/* top cherry ...*/}

			{!isInstaHand && cardLayout === 2 && (
				<div className={styles.suitTextAdditional} style={{ color: activeColor, ...suitSizeHelper[sizeKey] }}>
					{suitsMapperCode[suit]}
				</div>
			)}
		</div>
	)
}

export { CardImage }
